import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _dec4, _class, _class2, _CopyIcon, _EditIcon, _RemoveIcon, _CircularProgress;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import _ from 'lodash';
import Linkify from 'linkify-it';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Fab from '@mui/material/Fab';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Collapse from '@mui/material/Collapse';
import Snackbar from '@mui/material/Snackbar';
import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/Delete';
import { Interweave } from 'interweave';
import moment from 'moment/moment';
import LinkIcon from '@mui/icons-material/Link';
import NoSsr from '@mui/material/NoSsr';
import WarningIcon from '@mui/icons-material/Warning';
import AppContext from '../../../context';
import * as tourActions from '../../../actions/tours';
import RestrictedAccessModal from '../../../components/RestrictedAccessModal/RestrictedAccessModal';
import ConfirmDeleteDialog from '../../../components/statelessComponents/ConfirmDeleteDialog';
import Link from '../../../components/Link';
import LinkedTabs from '../../../components/statelessComponents/Tabs';
import ConfirmDeleteDescription from '../ConfirmDeleteDescription/ConfirmDeleteDescription';
import * as authActions from '../../../actions/auth';
import * as courseDetailsActions from '../../../actions/courseDetails';
import { isTourShown, isTrial, isProfessionalMainGroup, getStreamChatUrl, isUserFromWhitelabeledOrganization, userSkillEvaluationEnabled, isWhitelabeledOrganizationAdmin, isSupportAdminAuth, isEditor, isTeacher } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import history from '../../../history';
import LivestreamBadge from '../LivestreamBadge/LivestreamBadge';
import messages from './coursedetailsHeaderMessages';
import s from './CourseDetailsHeader.scss';
import large from '../../../components/large_screen.scss';
import secondary from '../../../components/statelessComponents/Tabs/presetsTabsScss/Secondary.scss';
import SkholeIcon21 from '../../../components/statelessComponents/Icons/SkholeIcon21';
import SkholeIcon03 from '../../../components/statelessComponents/Icons/SkholeIcon03';
import SkholeIcon02 from '../../../components/statelessComponents/Icons/SkholeIcon02';
import * as lessonDetailsActions from '../../../actions/lessonDetails';
import * as podcastLessonActions from '../../../actions/podcastLesson';
import { CopyIcon } from '../../../components/statelessComponents/Icons';
import CopyToClipboard from '../../../components/CopyToClipboard/CopyToClipboard';
import intlPropTypes from '../../../constants/intlPropTypes';
import { getApprovalStepId } from '../../../components/ApprovalStepListItem/ApprovalStepListItem';
import APPROVAL_TYPE from '../../../constants/approvalType';
import APPROVAL_STATUSES from '../../../constants/approvalStepStatuses';
import { getFirstForcedProgressionItem, isForcedProgressionItemIncomplete } from '../../../helpers/forcedProgression';
function escape(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
var linkify = Linkify();
function getLinkifiedContent(content) {
  var result = [];
  var out = escape(content);
  var matches = linkify.match(content);
  var last;
  if (matches) {
    last = 0;
    matches.forEach(function (match) {
      if (last < match.index) {
        result.push(escape(content.slice(last, match.index)).replace(/\r?\n/g, '<br>'));
      }
      result.push('<a target="_blank" href="');
      result.push(escape(match.url));
      result.push('">');
      result.push(escape(match.text));
      result.push('</a>');
      last = match.lastIndex;
    });
    if (last < content.length) {
      result.push(escape(content.slice(last)).replace(/\r?\n/g, '<br>'));
    }
    out = result.join('');
  }
  return out;
}
var CourseDetailsHeader = (_dec = withStyles(s), _dec2 = withStyles(large), _dec3 = withStyles(secondary), _dec4 = connect(function (state) {
  return {
    auth: state.auth,
    loading: state.courseDetails.loading,
    course: state.courseDetails.course,
    error: state.courseDetails.error,
    favoriteCourses: state.auth.favoriteCourses,
    relatedCourses: state.courseDetails.relatedCourses,
    loadingRelatedCourses: state.courseDetails.loadingRelatedCourses,
    totalRelatedCourses: state.courseDetails.totalRelatedCourses,
    textNotes: state.courseDetails.textNotes,
    videoNotes: state.courseDetails.videoNotes,
    totalDiscussions: state.discussions.total,
    lang: state.intl.locale,
    isTourOpen: isTourShown(state, 'courseDetails'),
    isLiveStreamChatShown: state.courseDetails.isLiveStreamChatShown,
    playPodcastAudio: state.podcastLesson.playPodcastAudio,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    lesson: state.lessonDetails.lesson,
    locale: state.intl.locale
  };
}, function (dispatch) {
  return bindActionCreators({
    loadAuth: authActions.loadAuth,
    saveFavoriteCourses: authActions.saveFavoriteCourses,
    getRelatedCourses: courseDetailsActions.getRelatedCourses,
    toggleTour: tourActions.toggleTour,
    resetCourseProgress: courseDetailsActions.resetCourseProgress,
    getCourseBySlug: courseDetailsActions.getCourseBySlug,
    toggleChat: courseDetailsActions.toggleChat,
    getLessonBySlug: lessonDetailsActions.getLessonBySlug,
    setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
    setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
    setPlayPodcastAudio: podcastLessonActions.setPlayPodcastAudio
  }, dispatch);
}), withCookies(_class = injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (_class2 = /*#__PURE__*/function (_Component) {
  _inherits(CourseDetailsHeader, _Component);
  var _super = _createSuper(CourseDetailsHeader);
  function CourseDetailsHeader(props) {
    var _this;
    _classCallCheck(this, CourseDetailsHeader);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getCurrentTabIndex", function () {
      var path = _this.context.route.path;
      var tabIndex = 'content';
      switch (path) {
        case '/:lang/courses/:courseSlug/discussions/:discussionId':
        case '/:lang/:organizationSlug/courses/:courseSlug/discussions/:discussionId':
          {
            tabIndex = 'discussions';
            break;
          }
        case '/:lang/courses/:courseSlug/discussions':
        case '/:lang/:organizationSlug/courses/:courseSlug/discussions':
          {
            tabIndex = 'discussions';
            break;
          }
        case '/:lang/courses/:courseSlug/notes':
        case '/:lang/:organizationSlug/courses/:courseSlug/notes':
          {
            tabIndex = 'notes';
            break;
          }
        case '/:lang/courses/:courseSlug/manage':
        case '/:lang/:organizationSlug/courses/:courseSlug/manage':
          {
            tabIndex = 'manage';
            break;
          }
        default:
          {
            tabIndex = 'content';
          }
      }
      return tabIndex;
    });
    _defineProperty(_assertThisInitialized(_this), "showConfirmDelete", function () {
      _this.setState({
        isConfirmDeleteOpen: true,
        isDeleted: false,
        deletingError: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideConfirmDelete", function () {
      _this.setState({
        isConfirmDeleteOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "showConfirmCopy", function () {
      _this.setState({
        isConfirmCopyOpen: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideConfirmCopy", function () {
      _this.setState({
        isConfirmCopyOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideConfirmDeleteSnackbar", function () {
      _this.setState({
        isDeleted: false,
        deletingError: ''
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeCourse", function () {
      var _this$props = _this.props,
        course = _this$props.course,
        lang = _this$props.lang;
      var organizationSlug = _this.context.organizationSlug;
      _this.setState({
        isDeleting: true,
        deletingError: ''
      });
      _this.context.fetch("/api/courses/".concat(course._id, "?forever"), {
        method: 'DELETE'
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
          var resText, json;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return res.text();
              case 2:
                resText = _context.sent;
                if (!res.ok) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                json = resText ? JSON.parse(resText) : {};
                throw new Error(json.message);
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).then(function () {
        _this.setState({
          isDeleting: false,
          isDeleted: true
        });
        _this.hideConfirmDelete();
        history.replace("/".concat(lang).concat(organizationSlug ? "/".concat(organizationSlug) : ''));
      })["catch"](function (deletingError) {
        _this.setState({
          isDeleting: false,
          deletingError: deletingError.message
        });
        console.error(deletingError);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleTelCom", function () {
      window.Intercom('show');
    });
    _defineProperty(_assertThisInitialized(_this), "closeRestrictedAccessModal", function () {
      _this.setState({
        isRestrictedAccessModalOpened: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCollapseDescription", function () {
      return _this.setState(function (prevState) {
        return {
          isShown: !prevState.isShown
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleFavorite", function (_id) {
      var _this$props2 = _this.props,
        favoriteCourses = _this$props2.favoriteCourses,
        saveFavoriteCourses = _this$props2.saveFavoriteCourses;
      if (favoriteCourses.includes(_id)) {
        return _this.context.fetch("/api/auth/favorite-courses/".concat(_id), {
          method: 'DELETE',
          headers: {
            'Content-Type': undefined,
            Accept: '*/*'
          }
        }).then(function () {
          return saveFavoriteCourses(_.without(favoriteCourses, _id));
        }).then(function () {
          _this.setState({
            isCourseFavoriting: false
          });
        })["catch"](function (error) {
          console.error(error);
          _this.setState({
            isCourseFavoriting: false
          });
        });
      }
      _this.setState({
        isCourseFavoriting: true
      });
      return _this.context.fetch("/api/auth/favorite-courses/".concat(_id), {
        method: 'PUT',
        headers: {
          'Content-Type': undefined,
          Accept: '*/*'
        }
      }).then(function () {
        return saveFavoriteCourses(favoriteCourses.concat([_id]));
      }).then(function () {
        _this.setState({
          isCourseFavoriting: false
        });
      })["catch"](function (error) {
        console.error(error);
        _this.setState({
          isCourseFavoriting: false
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCloseOldBrowserSnackbar", function () {
      _this.setState({
        isOldBrowserWarning: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hasAccess", function () {
      var _this$props3 = _this.props,
        auth = _this$props3.auth,
        course = _this$props3.course;
      return isLoggedIn(auth) && course.isAvailable;
    });
    _defineProperty(_assertThisInitialized(_this), "checkAuth", function (event, data) {
      var forbidForTrial = data && data.forbidForTrial;
      var auth = _this.props.auth;
      if (_this.hasAccess() && (!forbidForTrial || !isTrial(auth))) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      _this.setState({
        isRestrictedAccessModalOpened: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "resetCourseProgress", function () {
      var _this$props4 = _this.props,
        course = _this$props4.course,
        getCourseBySlug = _this$props4.getCourseBySlug,
        resetCourseProgress = _this$props4.resetCourseProgress,
        setOpenedPodcastLesson = _this$props4.setOpenedPodcastLesson,
        getFirstPodcastLesson = _this$props4.getFirstPodcastLesson;
      var fetch = _this.context.fetch;
      _this.setState({
        isCourseProgressResetting: true,
        isCourseProgressReset: false
      });
      resetCourseProgress();
      setOpenedPodcastLesson(null);
      return fetch("/api/courses/".concat(course._id, "/reset-progress"), {
        method: 'PUT'
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(res) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (res.ok) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", res.json());
              case 2:
                _this.setState({
                  isCourseProgressResetting: false,
                  isCourseProgressReset: true,
                  isConfirmResetOpen: false
                });
                return _context2.abrupt("return", getCourseBySlug(course.slug));
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).then(function () {
        if (course.type === 'podcast' && course.totalLessons === 1) {
          return getFirstPodcastLesson();
        }
        return Promise.resolve();
      })["catch"](function (error) {
        console.error(error);
        _this.setState({
          isCourseProgressResetting: false,
          resettingError: error && error.message
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleConfirmReset", function (isConfirmResetOpen) {
      _this.setState({
        isConfirmResetOpen: isConfirmResetOpen
      });
    });
    _defineProperty(_assertThisInitialized(_this), "hideConfirmResetSnackbar", function () {
      _this.setState({
        isCourseProgressReset: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "startPlayingPodcast", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(nextItem) {
        var _this$props5, setOpenedPodcastLesson, getLessonBySlug, course, setIsLoadingPodcastLesson, lesson, setPlayPodcastAudio;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this$props5 = _this.props, setOpenedPodcastLesson = _this$props5.setOpenedPodcastLesson, getLessonBySlug = _this$props5.getLessonBySlug, course = _this$props5.course, setIsLoadingPodcastLesson = _this$props5.setIsLoadingPodcastLesson, lesson = _this$props5.lesson, setPlayPodcastAudio = _this$props5.setPlayPodcastAudio;
              if (!(course.type !== 'podcast')) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              if (!(_.get(lesson, '_id') === _.get(nextItem, 'item._id'))) {
                _context3.next = 6;
                break;
              }
              setPlayPodcastAudio(true);
              return _context3.abrupt("return");
            case 6:
              setIsLoadingPodcastLesson(true);
              _context3.next = 9;
              return getLessonBySlug(_.get(nextItem, 'item.slug'), {
                courseId: course._id
              });
            case 9:
              setOpenedPodcastLesson(_.get(nextItem, 'item._id'), true, true);
              setIsLoadingPodcastLesson(false);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "scrollToApprovalStep", function (approvalStep, event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
      }
      var _this$props6 = _this.props,
        course = _this$props6.course,
        lang = _this$props6.lang;
      var organizationSlug = _this.context.organizationSlug;
      var id = getApprovalStepId(_.get(approvalStep, 'item', approvalStep));
      var scrollOffset = 90;
      var scrollToElement = function scrollToElement(attemptsLeft) {
        var element = document.getElementById(id);
        if (element) {
          var top = Math.max(element.getBoundingClientRect().top + window.pageYOffset - scrollOffset, 0);
          window.scroll({
            top: top,
            left: 0,
            behavior: 'smooth'
          });
          return;
        }
        if (attemptsLeft > 0) {
          window.setTimeout(function () {
            return scrollToElement(attemptsLeft - 1);
          }, 100);
        }
      };
      if (_this.getCurrentTabIndex() !== 'content') {
        history.push("/".concat(lang).concat(organizationSlug ? "/".concat(organizationSlug) : '', "/courses/").concat(course.slug));
      }
      window.setTimeout(function () {
        return scrollToElement(10);
      }, 0);
    });
    _this.state = {
      isShown: false,
      isCourseFavoriting: false,
      isRestrictedAccessModalOpened: false,
      isConfirmDeleteOpen: false,
      isDeleting: false,
      isDeleted: false,
      deletingError: '',
      isOldBrowserWarning: false,
      isCourseProgressResetting: false,
      isCourseProgressReset: false,
      isDescriptionShort: _.size(props.course.description) < 750,
      linkifiedDescription: getLinkifiedContent(props.course.description || ''),
      chatUrl: '',
      isConfirmCopyOpen: false
    };
    return _this;
  }
  _createClass(CourseDetailsHeader, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$props7, videoId, videoService, videoAppId, course, chatUrl;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$props7 = this.props, videoId = _this$props7.videoId, videoService = _this$props7.videoService, videoAppId = _this$props7.videoAppId, course = _this$props7.course;
              _context4.next = 3;
              return getStreamChatUrl(course.youtubeVideoUrl, {
                videoId: videoId,
                videoService: videoService,
                videoAppId: videoAppId
              }, this.context);
            case 3:
              chatUrl = _context4.sent;
              // eslint-disable-next-line react/no-did-mount-set-state
              this.setState({
                chatUrl: chatUrl
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function () {
      var _componentWillReceiveProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(nextProps) {
        var videoId, videoService, videoAppId, course, chatUrl, linkifiedDescription;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.props.course._id && nextProps.course._id && this.props.course._id !== nextProps.course._id)) {
                _context5.next = 8;
                break;
              }
              videoId = nextProps.videoId, videoService = nextProps.videoService, videoAppId = nextProps.videoAppId, course = nextProps.course;
              _context5.next = 4;
              return getStreamChatUrl(course.youtubeVideoUrl, {
                videoId: videoId,
                videoService: videoService,
                videoAppId: videoAppId
              }, this.context);
            case 4:
              chatUrl = _context5.sent;
              linkifiedDescription = getLinkifiedContent(course.description || '');
              if (linkifiedDescription !== this.state.linkifiedDescription) {
                this.setState({
                  linkifiedDescription: linkifiedDescription
                });
              }
              if (chatUrl !== this.state.chatUrl) {
                this.setState({
                  chatUrl: chatUrl
                });
              }
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function componentWillReceiveProps(_x4) {
        return _componentWillReceiveProps.apply(this, arguments);
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: "render",
    value: function render() {
      var _window,
        _window$location,
        _classNames8,
        _this2 = this,
        _classNames10;
      var _this$props8 = this.props,
        course = _this$props8.course,
        favoriteCourses = _this$props8.favoriteCourses,
        auth = _this$props8.auth,
        formatMessage = _this$props8.intl.formatMessage,
        textNotes = _this$props8.textNotes,
        videoNotes = _this$props8.videoNotes,
        lang = _this$props8.lang,
        loadingRelations = _this$props8.loadingRelations,
        courseRelations = _this$props8.courseRelations,
        totalDiscussions = _this$props8.totalDiscussions,
        toggleChat = _this$props8.toggleChat,
        isLiveStreamChatShown = _this$props8.isLiveStreamChatShown,
        streamingNow = _this$props8.streamingNow,
        timeLeft = _this$props8.timeLeft,
        videoService = _this$props8.videoService,
        openedPodcastLesson = _this$props8.openedPodcastLesson,
        lesson = _this$props8.lesson,
        playPodcastAudio = _this$props8.playPodcastAudio,
        disableContinueToBtn = _this$props8.disableContinueToBtn;
      var _this$state = this.state,
        isCourseFavoriting = _this$state.isCourseFavoriting,
        isRestrictedAccessModalOpened = _this$state.isRestrictedAccessModalOpened,
        isShown = _this$state.isShown,
        isConfirmDeleteOpen = _this$state.isConfirmDeleteOpen,
        isConfirmCopyOpen = _this$state.isConfirmCopyOpen,
        isDeleting = _this$state.isDeleting,
        isDeleted = _this$state.isDeleted,
        deletingError = _this$state.deletingError,
        isOldBrowserWarning = _this$state.isOldBrowserWarning,
        isCourseProgressResetting = _this$state.isCourseProgressResetting,
        resettingError = _this$state.resettingError,
        isCourseProgressReset = _this$state.isCourseProgressReset,
        isConfirmResetOpen = _this$state.isConfirmResetOpen,
        isDescriptionShort = _this$state.isDescriptionShort,
        linkifiedDescription = _this$state.linkifiedDescription,
        chatUrl = _this$state.chatUrl;
      var organizationSlug = this.context.organizationSlug;
      var courseItems = _(course && course.sections || []).filter(function (item) {
        return !item.isContentHidden;
      }).map('items').flatten().value();
      var completedSectionItemsNumber = course.completedLessons + course.completedQuizzes + course.completedApprovalSteps;
      var isApprovalStepCompleted = function isApprovalStepCompleted(sectionItem) {
        return sectionItem.itemType === 'Approval' && (sectionItem.isCompleted || sectionItem.approvalStatus === APPROVAL_STATUSES.APPROVED);
      };
      var firstIncompleteBlockProgressApprovalIndex = courseItems.findIndex(function (sectionItem) {
        return sectionItem.itemType === 'Approval' && _.get(sectionItem, 'item.approvalType') === APPROVAL_TYPE.BLOCK_PROGRESS && !isApprovalStepCompleted(sectionItem);
      });
      var firstIncompleteBlockProgressApproval = firstIncompleteBlockProgressApprovalIndex === -1 ? undefined : courseItems[firstIncompleteBlockProgressApprovalIndex];
      var getSectionItemIndex = function getSectionItemIndex(sectionItem) {
        return courseItems.findIndex(function (item) {
          return _.get(item, '_id') === _.get(sectionItem, '_id');
        });
      };
      var isCertificateBlocked = courseItems.some(function (sectionItem) {
        return sectionItem.itemType === 'Approval' && _.get(sectionItem, 'item.approvalType') === APPROVAL_TYPE.BLOCK_CERTIFICATE && !isApprovalStepCompleted(sectionItem);
      });
      var firstForcedProgressionItem = getFirstForcedProgressionItem(course);
      var nextItem = course.forcedProgression ? firstForcedProgressionItem : _.find(courseItems, function (sectionItem) {
        return _.get(sectionItem, 'item._id') === course.lastAccessItemId && isForcedProgressionItemIncomplete(sectionItem);
      });
      if (!nextItem) {
        nextItem = firstForcedProgressionItem;
      }
      if (firstIncompleteBlockProgressApproval && (!nextItem || getSectionItemIndex(nextItem) > firstIncompleteBlockProgressApprovalIndex)) {
        nextItem = firstIncompleteBlockProgressApproval;
      }
      if (!isLoggedIn(auth)) {
        nextItem = courseItems[0];
      }
      var showEvaluationModal = function showEvaluationModal(item) {
        var isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
        var isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);
        return (!isWhitelabeled || isUserSkillEvaluationEnabled) && !_.get(course, 'isUserSkillEvaluated') && !course.progress && !completedSectionItemsNumber && _.get(course, 'sections[0].items[0].item._id') === _.get(item, 'item._id');
      };
      var nextUrl;
      if (nextItem && nextItem.itemType === 'Quiz') {
        nextUrl = "/courses/".concat(course.slug, "/quizzes/").concat(_.get(nextItem, 'item._id', '')).concat(showEvaluationModal(nextItem) ? '?showEvaluationModal' : '');
      }
      if (nextItem && nextItem.itemType === 'Lesson') {
        nextUrl = "/courses/".concat(course.slug, "/lessons/").concat(_.get(nextItem, 'item.slug', '')).concat(showEvaluationModal(nextItem) ? '?showEvaluationModal' : '');
      }
      if (nextItem && (course.type === 'podcast' || nextItem.itemType === 'Approval')) {
        nextUrl = "/courses/".concat(course.slug);
      }
      var isFavorite = (favoriteCourses || []).includes(course._id);
      var hasNotes = !![].concat(_.reject(_.map(textNotes, 'notes'), function (item) {
        return !item.length;
      })).concat(_.reject(_.map(videoNotes, 'notes'), function (item) {
        return !item.length;
      })).length;
      var notesCount = _.sumBy(textNotes, function (item) {
        return item.notes.length;
      }) + _.sumBy(videoNotes, function (item) {
        return item.notes.length;
      });
      var discussionsLabel = formatMessage(messages.discussionTabLabel);
      var notesLabel = formatMessage(messages.notesTabLabel);
      if (isLoggedIn(auth)) {
        discussionsLabel = formatMessage(messages.discussionTabLabelWithCount, {
          count: totalDiscussions > 100 ? '99+' : totalDiscussions
        });
        notesLabel = formatMessage(messages.notesTabLabelWithCount, {
          count: notesCount > 100 ? '99+' : notesCount
        });
      }
      var courseDescriptionLines = ((course.description || '').match(/\n/g) || '').length + 1;
      var courseDescriptionLength = _.get(course, 'description.length', 0);
      var shouldBeCollapsed = courseDescriptionLines > 3 || courseDescriptionLength > 150;
      var isBrowser = typeof window !== 'undefined';
      var courseUrl = "".concat(isBrowser ? (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin : '', "/").concat(this.props.locale).concat(this.context.organizationSlug ? "/".concat(this.context.organizationSlug) : '', "/courses/").concat(course.slug, "?socialSharing");
      var forceCourseRestartForTask = course.forceCourseRestartForTask && course.type !== 'livestream';
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("section", {
        className: classNames(s.topPart, _defineProperty({}, s.livestream, course.type === 'livestream')),
        style: {
          backgroundImage: "url(".concat(this.context.cloudfrontUrl, "/").concat(_.get(course, 'image.path', 'default.svg'), ")")
        }
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(s.topPartContent, large.generalSection)
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "h1",
        className: classNames(s.title, _defineProperty({}, s.notDisplayOnMobile, course.type === 'livestream' && timeLeft < 0)),
        "data-test": "course-title"
      }, void 0, course.name), !!course.time && /*#__PURE__*/_jsx(Typography, {
        className: s.mediaDurations
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.mediaDurationsTooltip)
      }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.mediaDurations), "\xA0", !!course.timeHours && [/*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.studyTimeHours, {
        values: {
          time: course.timeHours
        }
      })), ' '], !!course.timeMinutes && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.studyTimeMinutes, {
        values: {
          time: course.timeMinutes
        }
      }))))), !!course.studyTimeEstimation && course.studyTimeEstimationType !== 'hide' && /*#__PURE__*/_jsx(Typography, {
        className: s.studyTime
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.recommendedStudyTimeTooltip)
      }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.recommendedStudyTime), "\xA0", !!course.studyTimeEstimationHours && [/*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.studyTimeHours, {
        values: {
          time: course.studyTimeEstimationHours
        }
      })), ' '], !!course.studyTimeEstimationMinutes && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.studyTimeMinutes, {
        values: {
          time: course.studyTimeEstimationMinutes
        }
      }))))), !!course.autoHideDate && /*#__PURE__*/_jsx(Typography, {
        color: "secondary"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.autoHideDate, {
        values: {
          date: moment(course.autoHideDate).format('YYYY-MM-DD')
        }
      }))), /*#__PURE__*/_jsx(LivestreamBadge, {
        timeLeft: timeLeft,
        course: course,
        streamingNow: streamingNow,
        className: classNames(_defineProperty({}, s.notDisplayOnTablet, timeLeft <= 0))
      }), /*#__PURE__*/_jsx(Typography, {
        className: classNames(s.description, s.notDisplayOnMobile, _defineProperty({}, s.width75, isDescriptionShort && course.type === 'livestream'))
      }, void 0, /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: linkifiedDescription
      }))), !_.isEmpty(course.description) && /*#__PURE__*/_jsx(Collapse, {
        className: classNames(s.descriptionOnlyMobile, _defineProperty({}, s.livestreamDescriptionMobile, course.type === 'livestream')),
        "in": isShown,
        collapsedSize: "62px"
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        className: s.descrText
      }, void 0, /*#__PURE__*/_jsx(Interweave, {
        content: linkifiedDescription
      })), shouldBeCollapsed && isShown && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "pzpIhhUkgUcADC9j23bCp",
        className: classNames(s.collapseReadBtn, _defineProperty({}, s.livestream, course.type === 'livestream')),
        onClick: this.toggleCollapseDescription
      }, void 0, formatMessage(messages.hideLabel))), shouldBeCollapsed && !isShown && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "QleQ0Xgtv08VtK6NjXR68",
        className: classNames(s.collapseReadBtn, _defineProperty({}, s.livestream, course.type === 'livestream')),
        onClick: this.toggleCollapseDescription
      }, void 0, formatMessage(messages.readMoreLabel)), forceCourseRestartForTask && /*#__PURE__*/_jsx("div", {
        className: s.forceCourseRestartForTaskNotice
      }, void 0, /*#__PURE__*/_jsx(WarningIcon, {
        className: s.alertIcon
      }), /*#__PURE__*/_jsx(Typography, {
        className: classNames(s.descrText)
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.forceCourseRestartForTaskNotice, {
        values: {
          months: course.forceCourseRestartMonths
        }
      })))), /*#__PURE__*/_jsx("div", {
        className: classNames(s.courseActions, (_classNames8 = {}, _defineProperty(_classNames8, s.actionsBlockLivestream, !course.certificate && course.type === 'livestream'), _defineProperty(_classNames8, s.noDescription, !course.description), _classNames8))
      }, void 0, /*#__PURE__*/_jsx("div", {
        className: classNames(s.leftActionsBlock)
      }, void 0, (nextItem && this.hasAccess() || _.get(nextItem, 'item.isGloballyFree')) && /*#__PURE__*/_jsx(Tooltip, {
        title: _.get(nextItem, 'item.name', '').length > 19 && completedSectionItemsNumber ? formatMessage(messages.continueToBtnLabel, {
          lessonName: _.get(nextItem, 'item.name', '')
        }) : ''
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "EMHLA0hT5YYVzxqh-dlRs",
        component: Link,
        className: s.button,
        id: "start-course-btn",
        variant: "contained",
        classes: {
          label: classNames(s.actionLabel, _defineProperty({}, s.smallActionLabel, course.certificate && _.get(nextItem && nextItem, 'item.name', '').length > 19)),
          disabled: s.disabledBtn
        },
        disabled: course.type === 'podcast' && (openedPodcastLesson && playPodcastAudio && _.get(lesson, 'audios.length') || disableContinueToBtn) || forceCourseRestartForTask,
        to: nextUrl,
        onClick: function onClick(event) {
          if (nextItem.itemType === 'Approval') {
            _this2.scrollToApprovalStep(nextItem, event);
            return;
          }
          if (course.type === 'podcast') {
            _this2.startPlayingPodcast(nextItem);
          }
        }
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon21, {
        className: s.playIconBtn,
        color: "#fff"
      }), completedSectionItemsNumber ? /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.continueToBtnLabel, {
        values: {
          lessonName: _.get(nextItem, 'item.name', '')
        }
      })) : /*#__PURE__*/React.createElement(FormattedMessage, messages.startBtnLabel))), !this.hasAccess() && !_.get(nextItem, 'item.isGloballyFree') && course.type !== 'livestream' && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "bcY4SjdP56YTX8jZYywNZ",
        onClick: this.checkAuth,
        className: s.button,
        classes: {
          label: s.actionLabel
        },
        disabled: forceCourseRestartForTask
      }, void 0, /*#__PURE__*/_jsx(SkholeIcon21, {
        className: s.playIconBtn,
        color: "#fff"
      }), /*#__PURE__*/React.createElement(FormattedMessage, messages.startBtnLabel)), course.certificate && !isCertificateBlocked && /*#__PURE__*/_jsx(Button, {
        href: "/".concat(lang).concat(organizationSlug ? "/".concat(organizationSlug) : '', "/cert/").concat(course.certificate.code),
        component: "a",
        target: "_blank",
        variant: "contained",
        className: classNames(s.button),
        classes: {
          label: s.actionLabel
        }
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.showCertificateBtnLabel)), this.hasAccess() && !!completedSectionItemsNumber && course.type !== 'livestream' && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "RHtrxWimEXfCM8C_LDU29",
        onClick: function onClick() {
          return _this2.toggleConfirmReset(true);
        },
        disabled: isCourseProgressResetting,
        className: s.button,
        classes: {
          label: s.actionLabel
        },
        variant: "contained",
        id: "restart-course-btn"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.resetCourseProgress))), course.type === 'livestream' && timeLeft <= 0 && course.enableStreamChat && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "a6vNEipJcuVGw9tMD8TzR",
        className: classNames(s.button, s.notDisplayOnMobile),
        classes: {
          label: s.actionLabel
        },
        type: "button",
        onClick: toggleChat
      }, void 0, !isLiveStreamChatShown && /*#__PURE__*/React.createElement(FormattedMessage, messages.viewLivestreamChat), isLiveStreamChatShown && /*#__PURE__*/React.createElement(FormattedMessage, messages.hideLivestreamChat)), course.type === 'livestream' && timeLeft <= 0 && course.enableStreamChat && videoService === 'vimeo' && /*#__PURE__*/_jsx(Button, {
        className: classNames(s.button, s.notDisplayOnDesktop),
        classes: {
          label: s.actionLabel
        },
        href: chatUrl,
        target: "_blank"
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.viewLivestreamChat)), this.hasAccess() && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "z0YcrG8-RTtDkFTo2RHuc",
        variant: "contained",
        className: classNames(s.transparentBtn, s.button, s.notDisplayOnMobile),
        onClick: this.toggleTelCom
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.giveCourseFedbackLabel))), course.type !== 'livestream' && _.has(course, 'progress') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(LinearProgress, {
        variant: "determinate",
        value: course.progress,
        className: s.progress,
        classes: {
          colorPrimary: s.progressBarColorPrimary
        },
        "aria-label": formatMessage(messages.progressBarLabel)
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        component: "h2",
        className: s.progressValue
      }, void 0, course.progress, "%")), isLoggedIn(auth) && /*#__PURE__*/_jsx("div", {
        className: s.buttonsContainer
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "2u0DN4JA_o8I-h6Ybw-AA",
        className: classNames((_classNames10 = {}, _defineProperty(_classNames10, s.removeFromFavorite, isFavorite), _defineProperty(_classNames10, s.addToFavorite, !isFavorite), _classNames10)),
        onClick: function onClick() {
          return _this2.toggleFavorite(course._id);
        },
        disabled: isCourseFavoriting
      }, void 0, !isFavorite ? /*#__PURE__*/React.createElement(FormattedMessage, messages.addToBtnLabel) : /*#__PURE__*/React.createElement(FormattedMessage, messages.removeFromBtnLabel), isFavorite ? /*#__PURE__*/_jsx(SkholeIcon02, {
        className: s.favoriteCourseIcon,
        color: "#fff"
      }) : /*#__PURE__*/_jsx(SkholeIcon03, {
        className: s.favoriteCourseIconBorder,
        color: "#fff"
      })), isEditor(auth) && /*#__PURE__*/_jsx(CopyToClipboard, {
        className: s.shareButtonContainer,
        copyText: courseUrl
      }, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "EzG1wGOxDHUxu62SViCAx",
        className: s.shareBtn,
        disabled: isCourseFavoriting
      }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.shareBtnLabel), /*#__PURE__*/_jsx(LinkIcon, {
        className: s.favoriteCourseIcon
      }))))), course.type !== 'livestream' && /*#__PURE__*/_jsx("nav", {
        className: classNames(s.tabsBlock, large.generalSection)
      }, void 0, /*#__PURE__*/_jsx(LinkedTabs, {
        currentTabIndex: this.getCurrentTabIndex(),
        classes: {
          root: secondary.root,
          scrollButtons: secondary.scrollButtons,
          tabsIndicator: secondary.tabsIndicator,
          tabRoot: secondary.tabRoot,
          tabLabel: secondary.tabLabel
        },
        tabs: [{
          label: formatMessage(messages.contentTabLabel),
          linkTo: "/courses/".concat(course.slug),
          value: 'content'
        }].concat([{
          label: discussionsLabel,
          linkTo: "/courses/".concat(course.slug, "/discussions"),
          onClick: function onClick(event) {
            return _this2.checkAuth(event, {
              forbidForTrial: true
            });
          },
          value: 'discussions'
        }], [(hasNotes || !isLoggedIn(auth)) && course.type !== 'podcast' && {
          label: notesLabel,
          linkTo: "/courses/".concat(course.slug, "/notes"),
          onClick: this.checkAuth,
          value: 'notes'
        }], _toConsumableArray((isTeacher(auth) || isEditor(auth)) && course.hasApprovalStepsManagementPermissions ? [{
          label: formatMessage(messages.manageTabLabel),
          linkTo: "/courses/".concat(course.slug, "/manage"),
          onClick: this.checkAuth,
          value: 'manage'
        }] : []))
      })), /*#__PURE__*/_jsx(Modal, {
        open: isRestrictedAccessModalOpened,
        onClose: this.closeRestrictedAccessModal
      }, void 0, /*#__PURE__*/_jsx(RestrictedAccessModal, {
        onClose: this.closeRestrictedAccessModal
      }))), course.hasEditPermission && (isWhitelabeledOrganizationAdmin(auth) || isSupportAdminAuth(auth)) && /*#__PURE__*/_jsx("div", {
        className: s.copyBtn
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.copyBtn)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        "data-test-id": "ZA4sWEy58QkHjuxT4c0sS",
        color: "primary",
        type: "button",
        className: s.btn,
        onClick: this.showConfirmCopy,
        id: "copy-course-btn"
      }, void 0, _CopyIcon || (_CopyIcon = /*#__PURE__*/_jsx(CopyIcon, {
        color: "secondary"
      }))))), course.hasEditPermission && /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx("div", {
        className: s.editBtn
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.editCourse)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        color: "primary",
        className: s.btn,
        "aria-label": formatMessage(messages.editCourseBtnLabel),
        component: Link,
        to: "/edit/courses/".concat(course._id),
        id: "edit-course-btn"
      }, void 0, _EditIcon || (_EditIcon = /*#__PURE__*/_jsx(EditIcon, {})))))), course.hasFullEditPermission && /*#__PURE__*/_jsx("div", {
        className: s.deleteBtn
      }, void 0, /*#__PURE__*/_jsx(Tooltip, {
        title: formatMessage(messages.deleteBtn)
      }, void 0, /*#__PURE__*/_jsx(Fab, {
        "data-test-id": "zAW9C_E47EQexu7tBo2dv",
        color: "secondary",
        type: "button",
        className: s.btn,
        onClick: this.showConfirmDelete,
        disabled: isDeleting,
        id: "remove-course-btn"
      }, void 0, _RemoveIcon || (_RemoveIcon = /*#__PURE__*/_jsx(RemoveIcon, {}))))), /*#__PURE__*/_jsx(ConfirmDeleteDialog, {
        isShown: isConfirmCopyOpen,
        onClose: this.hideConfirmCopy,
        deleteBtnId: "confirm-copy-course",
        submitColor: "primary",
        deleteBtnLabel: /*#__PURE__*/_jsx(Link, {
          className: s.copyConfirmBtn,
          to: "/edit/courses/new?courseIdToCopy=".concat(course._id)
        }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, messages.copyConfirmationSubmitLabel)),
        title: /*#__PURE__*/React.createElement(FormattedMessage, messages.copyConfirmationTitle),
        disableBackdropClick: true,
        isDeleting: false
      }), /*#__PURE__*/_jsx(ConfirmDeleteDialog, {
        isShown: isConfirmDeleteOpen,
        onClose: this.hideConfirmDelete,
        onCloseSnackbar: this.hideConfirmDeleteSnackbar,
        submit: this.removeCourse,
        isDeleting: isDeleting || loadingRelations,
        isDeleted: isDeleted,
        deletingError: deletingError,
        title: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.submitDeleteItemMsg, {
          values: {
            name: _.get(course, 'name', '').toLowerCase()
          }
        })),
        snackbarMessage: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.itemRemoved, {
          values: {
            name: _.get(course, 'name', '')
          }
        })),
        description: /*#__PURE__*/_jsx("div", {}, void 0, loadingRelations && /*#__PURE__*/_jsx("div", {
          className: s.loadingWrapper
        }, void 0, _CircularProgress || (_CircularProgress = /*#__PURE__*/_jsx(CircularProgress, {
          size: 100,
          thickness: 4
        }))), !loadingRelations && /*#__PURE__*/_jsx(ConfirmDeleteDescription, {
          courseRelations: courseRelations
        })),
        id: "confirm-remove-course-dialog"
      }), /*#__PURE__*/_jsx(ConfirmDeleteDialog, {
        isShown: isConfirmResetOpen,
        onClose: function onClose() {
          return _this2.toggleConfirmReset(false);
        },
        onCloseSnackbar: this.hideConfirmResetSnackbar,
        submit: this.resetCourseProgress,
        isDeleting: isCourseProgressResetting,
        isDeleted: isCourseProgressReset,
        deletingError: resettingError,
        deleteBtnId: "confirm-reset-course-btn",
        title: /*#__PURE__*/React.createElement(FormattedMessage, messages.resetCourseTitle),
        snackbarMessage: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.courseProgressResetSnackbar, {
          values: {
            name: _.get(course, 'name', '')
          }
        })),
        description: /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.courseProgressResetDescription, {
          values: {
            teacher: formatMessage(isProfessionalMainGroup(auth) ? messages.teacherProfessional : messages.teacher)
          }
        }))),
        deleteBtnLabel: /*#__PURE__*/React.createElement(FormattedMessage, messages.resetCourseProgress)
      }), /*#__PURE__*/_jsx(Snackbar, {
        open: isOldBrowserWarning,
        onClose: this.handleCloseOldBrowserSnackbar,
        autoHideDuration: 3000,
        message: formatMessage(messages.browserDoesNotSupportCaching)
      }));
    }
  }]);
  return CourseDetailsHeader;
}(Component), _defineProperty(_class2, "defaultProps", {
  course: {},
  courseRelations: {},
  loadingRelations: false,
  videoId: '',
  videoService: '',
  videoAppId: '',
  openedPodcastLesson: '',
  setOpenedPodcastLesson: _.noop,
  playPodcastAudio: false,
  getFirstPodcastLesson: _.noop,
  lesson: {},
  disableContinueToBtn: false
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class) || _class) || _class);
export { CourseDetailsHeader as default };